import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Jobs() {
    return (
        <Default>
            <Head>
                <title>Vacature - (Nazorg) Fitness instructeur</title>
                <link rel="canonical" href={route("vacancy3")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE is altijd op zoek naar nieuwe trainers om hun klanten te voorzien van de juiste kennis en begeleiding bij het sporten. Kom jij ons team versterken?"
                />
                <meta
                    property="og:description"
                    content="WE ARE is altijd op zoek naar nieuwe trainers om hun klanten te voorzien van de juiste kennis en begeleiding bij het sporten. Kom jij ons team versterken?"
                />
                <meta property="og:url" content={route("vacancy3")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Vacature - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-7xl">
                        Ben jij klaar om deel uit te maken van een team dat
                        levens verandert?
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="requirements"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Meer informatie
                        </Link>
                    </div>
                </Hero>

                <div
                    className="relative xs:p-8 sm:p-8 md:p-16 lg:p-32"
                    id="requirements"
                >
                    <div className="max-w-5xl mx-auto mt-12">
                        <p className="mt-5 text-xl text-gray-100">
                            Bij WE ARE geloven we in de kracht van
                            transformatie. We helpen onze leden niet alleen om
                            hun doelen te bereiken, zoals fitter worden,
                            afvallen of meer spiermassa opbouwen, maar we zorgen
                            er ook voor dat ze deze resultaten behouden. Met ons
                            unieke programma en complete nazorg verhogen we de
                            kwaliteit van leven van onze leden. En daar hebben
                            we jou voor nodig!
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Wat ga je doen?
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Als fitness instructeur van de nazorg bij WE ARE
                            speel je een cruciale rol in het succes van onze
                            leden. Je gaat:
                        </p>

                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Leden coachen op het gebied van voeding en
                                training, zodat ze hun transformatie kunnen
                                behouden.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Groepslessen geven, zoals HITT training en
                                Boxing, die inspireren en motiveren.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Leden helpen bij het uitvoeren van hun
                                trainingsschema's, waarbij je zorgt voor de
                                juiste techniek en uitvoering.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Het aanspreekpunt zijn voor alle leden die hun
                                transformatie hebben volbracht en willen
                                onderhouden
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Leden helpen bij de overstap van Personal
                                Training naar trainen in onze (vrije) fitness.
                            </li>
                        </ul>
                        <h2 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Wat zoeken we: persoonlijke eigenschappen
                        </h2>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Zelfstandigheid: Je kunt goed op eigen
                                initiatief werken en problemen oplossen.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Energie: Je hebt een positieve uitstraling en
                                weet anderen te motiveren.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Integriteit: Je bent betrouwbaar en handelt
                                altijd in het belang van de deelnemers.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Klantgerichtheid: Je stelt de behoeften van de
                                deelnemers centraal.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Initiatief: Je ziet kansen en komt proactief met
                                ideeën.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Besluitvaardigheid: Je durft beslissingen te
                                nemen en staat achter je keuzes.
                            </li>
                        </ul>
                        <h2 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Wat zoeken we: (Opleidings)eisen en werkervaring
                        </h2>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Minimaal 1 jaar ervaring in Personal training,
                                groepsfitness en fitness.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                De fysieke mogelijkheid om oefeningen en
                                bewegingen te demonstreren.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Je beoefend de sport zelf en bent het voorbeeld
                                voor onze deelnemers.
                            </li>
                        </ul>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Wat bieden wij?
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Bij WE ARE krijg je de kans om te groeien en te
                            excelleren in een stimulerende omgeving. Wij bieden:
                        </p>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Baan voor 36 uur – 40 uur per week (parttime ook
                                mogelijk)
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een competitief salaris gebaseerd op jouw
                                ervaringen en kwaliteiten.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Flexibele werktijden (afhankelijk van het
                                rooster)
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een complete interne opleiding om jezelf te
                                ontwikkelen als een van de betere trainers in
                                omstreken
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Doorgroeimogelijkheden binnen het bedrijf
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Ontwikkelingsmogelijkheden door cursussen te
                                mogen volgen op kosten van WE ARE.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een jong, leuk en gemotiveerd team van collega's
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Mogelijkheid om zelf te trainen in de WE ARE
                                sportscholen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Veel en leuke bedrijfsuitjes / teambuilding om
                                het team nog hechter te maken
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een telefoon van de zaak
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een goede pensioenregeling
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Reiskostenvergoeding (in overleg)
                            </li>
                        </ul>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Waarom WE ARE?
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Bij ons draait het om meer dan alleen fitness. Het
                            gaat om het creëren van een gemeenschap waar
                            iedereen zich welkom voelt en zijn of haar doelen
                            kan bereiken. We zijn trots op ons unieke programma
                            dat niet alleen fysieke transformaties mogelijk
                            maakt, maar ook de algehele levenskwaliteit van onze
                            leden verbetert.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Solliciteren
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Ben jij de gedreven fitness instructeur die wij
                            zoeken? Wil jij deel uitmaken van een team dat het
                            verschil maakt? Stuur je cv en een motivatiebrief
                            naar{" "}
                            <a
                                href="mailto:info@we-are.club"
                                className="text-we-are-yellow font-medium"
                            >
                                info@we-are.club
                            </a>{" "}
                            en wie weet verwelkomen we jou binnenkort in ons
                            team!
                        </p>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
